import {BaseContainerModel} from "../../base-container.model";
import { bl_wf_md_transition_role_link_RowClass, bl_wf_md_transition_role_link_RowInterface} from "../../../dbschema";

export class WfMdTransitionRoleLinkContainerModel extends BaseContainerModel{
  bl_wf_md_transition_role_link: bl_wf_md_transition_role_link_RowInterface = new bl_wf_md_transition_role_link_RowClass();
}
